import { Box } from '@material-ui/core';
import _ from 'lodash';
import { t } from '@lingui/macro';
import { NgpLabelValue } from '../../form/NgpLabelValue';
import {
    AGENT_MODEL_LONG_DISPLAY_FIELD,
    AGENT_NETWORK_IPV4_LOCAL_FIELD,
    AGENT_NETWORK_IPV6_LOCAL_FIELD,
    AGENT_NAME_FIELD,
    AGENT_NETWORK_MAC_FIELD,
} from '../agents/AgentConstants';
import IPAddressUtilities from '../../../utilities/IPAddressUtilities';
import { useColumnStyles } from '../agents/AgentStyles';
import { renderStatusData, renderVersionData } from '../agents/AgentReadOnlyHelper';

export default function AgentReadOnlyVoip({ agent }) {
    const columnClasses = useColumnStyles();

    if (_.isEmpty(agent)) {
        return null;
    }

    const renderedStatus = renderStatusData(columnClasses, agent);
    const renderedVersion = renderVersionData(columnClasses, agent);
    const ipv6Local = IPAddressUtilities.formatIPv6(_.get(agent, AGENT_NETWORK_IPV6_LOCAL_FIELD));

    return (
        <Box mt={1.5} mb={0.5}>
            <NgpLabelValue dataLabel={t`Status`} dataValue={renderedStatus} />
            <NgpLabelValue dataLabel={t`Model`} dataValue={_.get(agent, AGENT_MODEL_LONG_DISPLAY_FIELD)} />
            <NgpLabelValue dataLabel={t`Name`} dataValue={_.get(agent, AGENT_NAME_FIELD)} />
            <NgpLabelValue dataLabel={t`Version`} dataValue={renderedVersion} />
            <NgpLabelValue dataLabel={t`Internal IPv4`} dataValue={_.get(agent, AGENT_NETWORK_IPV4_LOCAL_FIELD)} />
            {!_.isEmpty(ipv6Local) && <NgpLabelValue dataLabel={t`Internal IPv6`} dataValue={ipv6Local} />}
            <NgpLabelValue dataLabel={t`Admin MAC`} dataValue={_.get(agent, AGENT_NETWORK_MAC_FIELD)} />
        </Box>
    );
}
